<template>
  <div>
    <!-- <el-dialog v-dialogDrag class="custom-dialog" :title="propsData.title" :visible="visible" :width="propsData.width" :before-close="handleClose" :modal-append-to-body=true :append-to-body=false> -->
    <el-dialog v-dialogDrag class="custom-dialog" :title="propsData.title" :visible="visible" :width="propsData.width" :before-close="handleClose" :modal-append-to-body=false :append-to-body=false>
      <component :is="propsData.comName" :parentComData=propsData v-if='propsData.comName'>
      </component>
      <span slot="footer" class="dialog-footer" v-if="propsData.isFooter">
        <el-button @click="handleClose" size="mini">取 消</el-button>
        <el-button type="primary" @click="submit" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dialogDrag } from '@/libs/utils/directive.js'
export default {
  name: 'customDialog',
  props: {
    propsData: Object
  },
  computed: {
    visible() {
      return this.propsData.dialogVisible
    }
  },
  data() {
    return {}
  },
  watch:{
    // propsData:{
    //   handler(newV){
    //     if(newV){
    //       this.$emit('updatePropsData',newV)
    //     }
    //   },deep:true
    // }
  },
  methods: {
    submit(){
      this.$emit('submit')
    },
    handleClose() {
      this.propsData.dialogVisible = false
      // this.$emit('handleClose')
    }
  }
}
</script>

<style scoped lang='scss'>
.custom-dialog {
  ::v-deep {
    .el-dialog__header {
      height: 48px;
      padding: 0 10px;
      background-color: #0078d7;
      display: flex;
      align-items: center;
      color: white;
      .el-dialog__title {
        color: white;
      }
      .el-dialog__close {
        color: white;
      }
    }
    .el-dialog__body {
      padding-top: 0;
    }
    .el-dialog__footer {
      padding: 0 !important;
      text-align: right;
      box-sizing: border-box;
      background-color: #f0f4fa;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/customDialog.vue